import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=612c7450&scoped=true&"
import script from "./UserModal.vue?vue&type=script&lang=ts&"
export * from "./UserModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserModal.vue?vue&type=style&index=0&id=612c7450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612c7450",
  null
  
)

export default component.exports